import { render, staticRenderFns } from "./SearchResultB2C.vue?vue&type=template&id=cf48ce54&scoped=true&"
import script from "./SearchResultB2C.ts?vue&type=script&lang=ts&"
export * from "./SearchResultB2C.ts?vue&type=script&lang=ts&"
import style0 from "./SearchResultB2C.vue?vue&type=style&index=0&id=cf48ce54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf48ce54",
  null
  
)

export default component.exports